export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10474.ab0d7446.jpg";